import { grantsFreeMagnets } from '../../utils/offerPricing';
import { formatDeadline } from '../../utils/offerDeadline';

// What a package card shows for the free-magnets tier (issue #5218 items 7 and
// 9). Pure functions: every surface asks grantsFreeMagnets (the ONE
// interpreter) through these, so the badge, the checklist row, the magnet slot
// and the a-la-carte label appear and vanish together with the offer.

export const FREE_MAGNETS_BADGE = '+2 FREE MAGNETS';

// The badge text, or null when the tier is not live.
export const freeMagnetsBadge = (offer) => (grantsFreeMagnets(offer) ? FREE_MAGNETS_BADGE : null);

// The checklist row appended under the option's own contents:
// "(2) FREE Photo Magnets — offer ends Friday, October 24". Null when not live.
export function freeMagnetsRow(offer) {
  if (!grantsFreeMagnets(offer)) return null;
  const deadline = formatDeadline(offer.expiresOn);
  return `(2) FREE Photo Magnets${deadline ? ` — offer ends ${deadline}` : ''}`;
}

// The a-la-carte "Magnets" option on the pricelist (778 has one at $14.95;
// 877 needs one added in admin). Matched by name, the same way the checklist
// parser recognises a magnet row.
export const isMagnetsOption = (option) => /magnet/i.test(option?.name || '');

// The label that replaces the Magnets option's tagline while the tier is live.
export const magnetsOptionLabel = (option, offer) => (
  grantsFreeMagnets(offer) && isMagnetsOption(option) ? 'FREE with any package' : null
);
